export default __webpack_public_path__ + "static/media/product27_slides.e3c8c79b.webp";